import React, { useEffect, useRef, useState } from 'react'
import { string, func, any, arrayOf, bool, shape, object } from 'prop-types'
import './Table.scss'
import TableCard from './TableCard/TableCard'
import GenericRow from './TableRow/GenericRow'
import { scrollService } from '../../services/scrollService'
import useBreakpoint from '../../../dpe-usco/services/useBreakpoint'
import TableStatus from '../../../components/subComponents/TableStatus/TableStatus'

export const Table = props => {
  let [activeRow, setActiveRow] = useState()
  const [breakpoint] = useBreakpoint()
  const viewIsMobile = breakpoint === 'mobile'

  const fillHeader = (items, showTooltip) => {
    const refs = useRef({})
    useEffect(() => {
      const checkEllipsisText = () => {
        if (showTooltip) {
          Object.keys(refs.current).forEach(key => {
            const element = refs.current[key]
            if (element) {
              const isEllipsisActive = el => el.scrollWidth > el.clientWidth
              if (isEllipsisActive(element)) {
                element.setAttribute('title', element.textContent)
              } else {
                element.removeAttribute('title')
              }
            }
          })
        }
      }
      checkEllipsisText()
      window.addEventListener('resize', checkEllipsisText)
      return () => {
        window.removeEventListener('resize', checkEllipsisText)
      }
    }, [props]) 
    

    if (items[0] && typeof items[0] === 'string') {
      return items.map((item, index) => {
        let classes = 'cell '
        if (typeof items[index] === 'function') {
          return <div key={items[index].value}>{item()}</div>
        }
        if (
          props.structure.rowFormat &&
          props.structure.rowFormat[props.structure.dataKeys[index]] &&
          props.structure.rowFormat[props.structure.dataKeys[index]].customStyle
        ) {
          if (
            props.structure.rowFormat[props.structure.dataKeys[index]]
              .overwriteStyles
          ) {
            classes =
              props.structure.rowFormat[props.structure.dataKeys[index]]
                .customStyle
          } else {
            classes =
              classes +
              props.structure.rowFormat[props.structure.dataKeys[index]]
                .customStyle
          }
        }
        return (
          <div key={item} className={classes} ref={el => refs.current[item] = el}>
            {item}
          </div>
        )
      })
    } else if (items[0]) {
      return items.map(item => {
        return item.format()
      })
    }
  }
  const populateRows = () => {
    let referenceData = props.data
    if (referenceData && referenceData.length) {
      return referenceData.map((item, index) => {
        const uniqueID = props.structure?.rowKey
          ? item[props.structure.rowKey]
          : index
        const tempProps = {
          id: uniqueID,
          rowContent: item,
          handleClick: rowClickHandler,
          isActive: uniqueID === activeRow,
          header: props.headers,
          structure: props.structure,
          customRowClass: item.customRowClass,
          index
        }
        if (props.subRowStructure) {
          tempProps.subRowStructure = props.subRowStructure
        }
        return <GenericRow key={uniqueID} {...tempProps} replantOrLost={props.replantOrLost} deleteMultipleScaleTickets={props.deleteMultipleScaleTickets} productionPlanId={props.productionPlanId}/>
      })
    } else {
    
      return <div>{props.statusComponent}</div>
    }
  }

  const populateCards = () => {
    let referenceData = props.data
    if (referenceData) {
      return referenceData.map((item, index) => {
        const uniqueID = item.uniqueID
          ? item.uniqueID
          : index + '-' + (item.Name || item.ship_to_name || item.reseller_name)
        const tempProps = {
          id: uniqueID,
          rowContent: item,
          handleClick: rowClickHandler,
          isActive: uniqueID === activeRow,
          header: props.headers,
          structure: props.structure,
          index
        }
        if (props.subRowStructure) {
          tempProps.subRowStructure = props.subRowStructure
        }
        return <TableCard key={uniqueID} {...tempProps} />
      })
    } else {
      console.error('table data not found')
    }
  }

  const rowClickHandler = (rowContent, isSubmenu) => {
    const { [props.structure.rowKey]: id } = rowContent
    if (!isSubmenu) {
      if (id !== activeRow) {
        if (props.dropdownCallback) {
          props.dropdownCallback(rowContent)
        }
        setActiveRow(id)
      } else {
        setActiveRow(null)
      }
    }
  }

  const handleScroll = e => {
    scrollService(e, props.onScrollAPI)
  }
 
  if (viewIsMobile) {
    return (
      <div className="table ml25 mr25" onScroll={handleScroll}>
        <div className="tableHeader pl16 df fxdrc h90">
          <div className="df jcsb w100% aic h44">
            <input type="text" />
            <button>Filter</button>
          </div>
          <div className="df jcsb w100% aic h44 pl16 pr16">
            <div>{props.structure.headers[0]?.value}</div>
            <div>{props.structure.headers[1]?.value}</div>
          </div>
        </div>
        <div className="tableBody" style={props.grainReceivers && { maxHeight: '675px' }}>{populateCards()}</div>
        <div className="tableLoader">
          {props.statusComponent}
        </div>
      </div>
    )
  } else {
    return (
      <div
        className="table"
        role="grid"
        onScroll={handleScroll}
        data-testid={props.dataTestId}
      >
        <div
          className={`tableHeader ${
            props.structure.hasSubRow ? 'pl60' : 'pl16'
            }`}
        >
          {fillHeader(props.structure.headers,props.structure.showTooltip || undefined)}
        </div>
        <div className="tableBody" style={props.grainReceivers && { maxHeight: '675px' }}>
          {!props.statusComponent && populateRows()}
        </div>  

        { props.isLoadExtraData && (<div className='extraDataLoader'>
          <div className='loaderDiv'> <TableStatus status={'LOADING'} /> </div>
        </div> )}

        {!props.statusComponent && props.showYieldValue ? props.showYieldValue : null}
        
        {props.statusComponent && (
          <div className={`${props.statusComponentHeight || 'h150'} df jcc pt30`}>{props.statusComponent}</div>
        )}
        {props.bottomOfTable}
      </div>
    )
  }
}
export default Table

Table.propTypes = {
  dataTestId: string,
  subRowStructure: object,
  headers: arrayOf(string),
  data: arrayOf(any),
  dropdownCallback: func,
  isLoadExtraData: bool,
  onScrollAPI: func,
  statusComponent: object,
  structure: shape({
    rowKey: any,
    clickable: bool,
    customMemoAreEqual: func,
    hasIcon: bool,
    hasSubRow: bool,
    headers: arrayOf(any),
    rowFormat: object
  })
}
